import React from 'react';
import {Button} from 'react-bootstrap';
import {Draggable} from 'react-beautiful-dnd';

export default function Column(props) {
  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    background: isDragging ? 'lightgreen' : '#F8F8F8',
    ...draggableStyle
  });
  return (
    <Draggable
      key={props.index}
      draggableId={props.draggableId}
      index={props.index}
    >
      {(provided, snapshot) => (
        <div className="col-12 mt-2">
          <div
            className="info-box-drag"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getItemStyle(
              snapshot.isDragging,
              provided.draggableProps.style
            )}
          >
            <span className="close-icon">
              <i className="fa fa-times" onClick={()=>{props.onDelete(props.index)}}></i>
            </span>
            <div className="row">
              <span className="info-box-icon">
                <div className="numberCircle">
                  {String.fromCharCode(props.index + 65)}
                </div>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">{`${props.place.lat.toFixed(
                  4
                )} , ${props.place.lng.toFixed(4)}`}</span>
                <textarea
                  disabled
                  rows="2"
                  style={{fontSize: 12}}
                  value={`${props.place.name}`}
                ></textarea>
                {/* <span className="progress-description">{`${props.place.name}`}</span> */}
                {/* <div class="form-group">
                <Button
                  className="btn-xs spanbox float-right"
                  variant="outline-secondary"
                  onClick={()=>{props.onDelete(props.index)}}
                >
                  ลบ
                </Button>
              </div> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
}
